<template>
  <div>
    <div class="hero-static">
      <div class="content signup-footer">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
            <div class="block block-themed block-fx-shadow mb-0">
              <div class="block-header bg-success">
                <h3 class="block-title">Create Account</h3>
                <div class="block-options">
                  <router-link class="btn-block-option js-tooltip-enabled" to="/login" title="Sign In">
                    <i class="fa fa-sign-in-alt"></i>
                  </router-link>
                </div>
              </div>
              <div class="block-content">
                <div class="signup-content" id="content-top">
                  <h1 class="mb-2">GrowTracker</h1>
                  <p>Please fill the following details to create a new account.</p>
                  <alert-message></alert-message>
                  <form method="POST" v-on:submit.prevent name="signup">
                    <div class="py-3 row">
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <input type="text" class="form-control form-control-lg form-control-alt" id="first_name" placeholder="First Name*" v-model="user.firstName" name="firstName" v-validate="'required'" data-vv-as="First Name" @keyup="user.firstNameErr = ''">
                        <p v-if="errors.has('firstName')" class="error">{{ errors.first('firstName') }}</p>
                        <p v-if="user.firstNameErr" class="error">{{ user.firstNameErr }}</p>
                      </div>
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <input type="text" class="form-control form-control-lg form-control-alt" id="last_name" placeholder="Last Name*" v-model="user.lastName" name="lastName" v-validate="'required'" data-vv-as="Last Name" @keyup="user.lastNameErr = ''">
                        <p v-if="errors.has('lastName')" class="error">{{ errors.first('lastName') }}</p>
                        <p v-if="user.lastNameErr" class="error">{{ user.lastNameErr }}</p>
                      </div>
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <input v-mask="'(###) ###-####'" type="text" class="form-control form-control-lg form-control-alt" id="mobile_number" placeholder="Mobile Number (xxx) xxx-xxxx" v-model="user.mobileNumber" name="mobile" data-vv-as="Mobile Number">
                      </div>
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <input type="email" class="form-control form-control-lg form-control-alt" id="signup-email" v-model="user.email" name="email" placeholder="Email*" v-validate="'required|email'" data-vv-as="Email" @keyup="user.emailErr = ''" autocomplete="on">
                        <p v-if="errors.has('email')" class="error">The email field must contain a valid email.</p>
                        <p v-if="user.emailErr" class="error">{{user.emailErr}}</p>
                      </div>
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 password">
                        <input type="password" class="form-control form-control-lg form-control-alt input-group" id="password" v-model="user.password" name="password" placeholder="Password*" v-validate="'required|min:8|verify_password'" ref="user.password" data-vv-as="Password" autocomplete="new-password" @keyup="user.passwordErr = ''">
                        <p v-if="errors.has('password')" class="error">{{ errors.first('password') }}</p>
                        <p v-if="user.passwordErr" class="error">{{ user.passwordErr }}</p>
                        <p class="password-hint">
                          Password complexity: Make sure it's more than 15 characters OR at least 8 characters including a number, a lowercase letter, an uppercase letter and a special character. (Eg: xxY98*zz)
                        </p>
                        <span class="password-eye-icon fa fa-eye" id="show-password" @click="changePassWordInputType('password', 'show-password')"></span>
                      </div>
                      <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 password">
                        <input type="password" class="form-control form-control-lg form-control-alt" id="confirm-password" v-model="user.confirmPassword" name="confirmPassword" placeholder="Confirm Password*" v-validate="{required: true, is: user.password}" data-vv-as="Confirm Password" autocomplete="new-password">
                        <p v-if="errors.has('confirmPassword') && user.password" class="error">The password does not match.</p>
                        <p v-else-if="!user.password && errors.has('password')" class="error">The Password field is required.</p>
                        <span class="password-eye-icon fa fa-eye" id="show-confirm-password" @click="changePassWordInputType('confirm-password', 'show-confirm-password')"></span>
                      </div>
                    </div>
                  </form>
                    <div class="py-3">
                      <div v-for="(item, index) in facility" :key="index">
                        <div class="form-group clone-buttons">
                          <h4 id="facility" v-if="index == 0">Facility details</h4>
                          <button v-if="index == 0" href="#" title="Click to add more than one facility details" id='facilityIcon' @click="addFacility()" class="clone btn text-success" v-scroll-to="{ element:'#scrollDown', duration: 3000 }"><i class="fa fa-fw fa-plus-square mr-1"></i>Add</button>
                        </div>
                        <div v-bind:class="[ index == 0  ? 'border-facility block-content'  : 'remove-facility border-facility block-content' ]">
                          <div class="row">
                            <div v-if="index > 0" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">      
                              <button href="#" title="Click to delete fecility details" id='facilityIcon' @click="deleteFacility(index)" class="clone btn delete-icon"><i class="fa fa-trash-alt"></i></button>
                            </div>
                            <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 placeholder">
                              <input type="text" class="form-control form-control-lg form-control-alt" v-model="item.businessName" placeholder="Business Name*" :name="item.errBusinessName" v-validate="'required'" data-vv-as="Business Name" @keyup="item.businessNameErr = ''">
                              <p v-if="'errors.has(' + item.errBusinessName + ')'" class="error">{{ errors.first(item.errBusinessName) }}</p>
                              <p v-if="item.businessNameErr" class="error">{{ item.businessNameErr }}</p>
                            </div>
                            <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                              <auto-complete :map="item.autoComplete" :indexValue="index" @autofill-address="setPlaces"></auto-complete>
                            </div>
                            <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                              <input type="text" class="form-control form-control-lg form-control-alt" v-model="item.metrcUserApiKey" placeholder="Metrc User Api Key*" :name="item.errApiKey" v-validate="'required'" data-vv-as="Metrc User Api Key" @keyup="item.metrcUserApiKeyErr = ''">
                              <p v-if="'errors.has(' + item.errApiKey + ')'" class="error">{{ errors.first(item.errApiKey) }}</p>
                              <p v-if="item.metrcUserApiKeyErr" class="error">{{ item.metrcUserApiKeyErr }}</p>
                            </div>
                            <div class="form-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                              <input type="text" class="form-control form-control-lg form-control-alt" v-model="item.licenseNumber" placeholder="License Number*" :name="item.errLicenseNumber"  v-validate="{ required: true, regex: /^[a-zA-Z0-9-]+$/ }" data-vv-as="License Number" @keyup="item.licenseNumberErr = ''">
                              <p v-if="'errors.has(' + item.errLicenseNumber + ')'" class="error">{{ errors.first(item.errLicenseNumber) }}</p>
                              <p v-if="item.licenseNumberErr" class="error">{{ item.licenseNumberErr }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row d-flex justify-content-end button-loader">
                      <div class="col-md-12 col-xl-5 signup-button">
                        <button type="submit" v-bind:disabled="showLoader" class="btn btn-block btn-success" @click="signUp" v-scroll-to="{ element:'#content-top', duration: 2000 }">
                          <div><i class="fa fa-fw fa-plus mr-1"></i><span> Sign Up</span></div>
                          <span v-if="showLoader" class="modal-loader">
                            <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                          </span>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer id="scrollDown" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapActions } from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import Footer from '@/components/Footer';
import AlertMessage from '@/components/AlertMessage';
import VueMask from 'v-mask';
import AutoComplete from  '@/components/google-input/GoogleAutoSearch';
import { helper } from '@/helper.js';

import base64 from 'base-64';
import utf8 from 'utf8';
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);
Vue.use(VueMask, base64, VeeValidate, VueSpinners);  

VeeValidate.Validator.extend('verify_password', {
  getMessage: field => 'Please give a valid password according to the password complexity.',
  validate: value => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }
});

export default {
  name: 'Signup',
  data: () => ({
    user: {
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      mobileNumber: '',
      password: '',
      confirmPassword: '',
      emailErr: '',
      firstNameErr: '',
      lastNameErr: '',
      passwordErr: ''
    },
    facility: [{
      id: 0,
      businessName: '',
      address: '',
      metrcUserApiKey: '',
      licenseNumber: '',
      businessNameErr: '',
      licenseNumberErr: '',
      metrcUserApiKeyErr: '',
      errBusinessName: 'businessName_0',
      autoComplete: 'address_0',
      errApiKey: 'apiKey_0',
      errLicenseNumber: 'licenseNumber_0'
    }],
    counter: 0,
    showLoader: false
  }),
  components:{
    Footer,
    AlertMessage,
    AutoComplete,
    HashLoader
  },
  created() {
    this.clear();  
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    signUp() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showLoader = true;
          helper.sendPostRequest('/signup', {
            'user' : {
              'email': vm.user.email,
              'firstName': vm.user.firstName,
              'lastName': vm.user.lastName,
              'mobileNumber': vm.user.mobileNumber,
              'password': base64.encode(utf8.encode(vm.user.password)),
              'confirmPassword': base64.encode(utf8.encode(vm.user.confirmPassword))
            },
            'facility' : vm.facility,
            'submit' : 1
          }).then(function(data) {
            if (data && data.status === 'error') {
              vm.showLoader = false;
              if (typeof data.data.user !== 'undefined') {
                if (data.data.user.hasOwnProperty('firstName')) {
                  vm.user.firstNameErr = data.data.user.firstName;
                }
                if (data.data.user.hasOwnProperty('lastName')) {
                  vm.user.lastNameErr = data.data.user.lastName;
                }
                if (data.data.user.hasOwnProperty('email')) {
                  vm.user.emailErr = data.data.user.email;
                }
                if (data.data.user.hasOwnProperty('password')) {
                  vm.user.passwordErr = data.data.user.password;
                }
              }
              if (typeof data.data.facility !== 'undefined') {
                for (var i in data.data.facility) {
                  let v = data.data.facility[i];
                  if (v.hasOwnProperty('businessName')) {
                    vm.facility[i].businessNameErr = v.businessName;
                  }
                  if (v.hasOwnProperty('metrcUserApiKey')) {
                    vm.facility[i].metrcUserApiKeyErr = v.metrcUserApiKey;
                  }
                  if (v.hasOwnProperty('licenseNumber')) {
                    vm.facility[i].licenseNumberErr = v.licenseNumber;
                  }
                }
              }
            }
            if (data && data.status === 'success') {
              vm.showLoader = false;
              vm.$router.push('/login');
              vm.success(data.message);
            }
          }).catch(function() {
            vm.error('User registration failed.');
            vm.handleAlertMessage();
            vm.showLoader = false;
          });
        }
      });
    },
    addFacility() {
      this.counter++;
      this.facility.push({
        id: 0,
        businessName: '',
        address: '',
        apiKey: '',
        licenseNumber: '',
        businessNameErr: '',
        licenseNumberErr: '',
        metrcUserApiKeyErr: '',
        errBusinessName: `businessName_${this.counter}`,
        autoComplete: `address_${this.counter}`,
        errApiKey: `apiKey_${this.counter}`,
        errLicenseNumber: `licenseNumber_${this.counter}`
      });
    },
    deleteFacility(index) {
      this.facility.splice(index, 1);
    },
    changePassWordInputType(input, icon) {
      let inputType = this.$el.querySelector('#' + input).type;
      if (inputType === 'password') {
        this.$el.querySelector('#' + icon).classList.remove('fa-eye');
        this.$el.querySelector('#' + icon).classList.add('fa-eye-slash');
        this.$el.querySelector('#' + input).type = 'text';
      } else {
        this.$el.querySelector('#' + icon).classList.remove('fa-eye-slash');
        this.$el.querySelector('#' + icon).classList.add('fa-eye');
        this.$el.querySelector('#' + input).type = 'password';
      }
    },
    setPlaces(val) {
      let searchAddress = [];
      if (typeof val.addressValue.street_number !== 'undefined') {
        searchAddress.push(val.addressValue.street_number);
      }
      if (typeof val.addressValue.route !== 'undefined') {
        searchAddress.push(val.addressValue.route);
      }
      if (typeof val.addressValue.locality !== 'undefined') {
        searchAddress.push(val.addressValue.locality);
      }
      if (typeof val.addressValue.administrative_area_level_1 !== 'undefined') {
        searchAddress.push(val.addressValue.administrative_area_level_1);
      }
      if (typeof val.addressValue.country !== 'undefined') {
        searchAddress.push(val.addressValue.country);
      }
      if (typeof val.addressValue.postal_code !== 'undefined') {
        searchAddress.push(val.addressValue.postal_code);
      }
      this.facility[val.index].address = searchAddress.join(', ');
    },
    handleAlertMessage() {
      let vm = this;
      setTimeout(() => { vm.clear(); }, 5000);
    }
  }
};
</script>

<style>
#facility {
  text-align: left;
  display: inline-block;
  margin: 0;
  line-height: 32px;
}
.clone-buttons .clone.btn,
.signup-button {
  float: right;
}
.form-group {
  display: inline-block;
  width: 100%;
}
#facilityIcon .fa-trash-alt,
.error {
  color: red;
}
.clone.btn:focus {
  box-shadow: none;
}
.error,
.password-hint {
  font-size: 0.7rem;
}
.password-hint,
.error {
  line-height: 16px;
  padding-top: 5px;
  margin-bottom: 0 !important;
}
.border-facility {
  border: 1px solid #ccc;
}
.fa-trash-alt:parent {
  padding-top: 0;
}
.delete-icon {
    margin-top: 8px;
}
.remove-facility.block-content {
  padding-top: 0;
}
.py-3 .password {
  position: relative;
}
.py-3 .password-eye-icon {
  position: absolute;
  top: 16px;
  right: 25px;
}
.signup-button {
  padding-top: 23px;
  padding-bottom: 23px;
}
input {
  box-shadow: none;
}
.signup-content {
  padding: 1rem;
}
.signup-footer {
  min-height: calc(100vh - 61px);
  padding-bottom: 2rem;
}
</style>


// WEBPACK FOOTER //
// source/components/Signup.vue